import React, { useState } from "react";
import Logo from "../../assets/icons/Logo.svg";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import InputField from "../../components/fields/inputField";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { storeContactUs } from "../../apis/contact-api";
import ErrorMsg from "../../components/fields/errorMsg";
import Footer from "../../components/features/footer";
import Modal from "react-bootstrap/Modal";
import { Spinner } from "react-bootstrap";

const DeletionRequest = () => {
  const navigate = useNavigate();
  const [success, setsuccess] = useState(false);
  const [Message, setMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  const headingVariants = {
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, y: -20 },
  };

  const phoneRegex = /^\d{10}$/;
  const initialValues = {
    first_name: "",
    email: "",
    mobile: "",
    budget: "",
    description: "",
  };

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("Enter your Name"),
    email: Yup.string().required("Enter your email"),
    description: Yup.string().required("Enter your description"),
    mobile: Yup.string()
      .matches(phoneRegex, "Please enter the valid phone number")
      .required("Enter your phone number"),
  });

  const timeOutFnc = () => {
    setsuccess(false);
    setMessage(false);
  };

  const onSubmit = (values, { resetForm }) => {
    setLoading(true);
    try {
      const res = storeContactUs(
        values.first_name,
        values.mobile,
        values.email,
        values.description,
        values.budget
      );
      if (res.status === true) {
        setsuccess(true);
        setLoading(false);
        setTimeout(timeOutFnc, 3000);
        resetForm();
      } else {
        setsuccess(true);
        setLoading(false);
        setTimeout(timeOutFnc, 3000);
      }
    } catch (error) {
      setMessage(true);
      setLoading(false);
    }
  };

  return (
    <main>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        show={success}
        onHide={() => setsuccess(false)}
        centered
      >
        <Modal.Body className="p-5">
          <p className="fw_500 fs_18 text-success text-center text-capitalize">
            Thank you. We've received your request to delete your account.
          </p>
        </Modal.Body>
      </Modal>
      <Modal show={Message} onHide={() => setMessage(false)} centered>
        <Modal.Body className="p-5">
          <p className="fw_500 fs_18 text-danger text-center text-capitalize">
            Somthing went wrong , please try again later
          </p>
        </Modal.Body>
      </Modal>
      <section style={{ height: "110vh" }}>
        <nav
          className="p-2 py-3"
          style={{ background: "white", position: "sticky", top: 0 }}
        >
          <motion.div
            variants={headingVariants}
            initial="hidden"
            animate="visible"
          >
            <img
              onClick={() => navigate("/")}
              src={Logo}
              className="navbar-brand px-4 cursor_pointer"
              height={35}
            />
          </motion.div>
        </nav>
        <section className="my-2">
          <h1 className="text-center text-capitalize">
            Account deletion request
          </h1>
          <section className="w-100 mx-auto my-5" style={{ maxWidth: "40rem" }}>
            <p className="fs_16">{`We respect your right to control your data. If you wish to delete your account, you can request deletion here.`}</p>
            <h1 className="fs_18">
              What happens when you delete your account:
            </h1>
            <ul>
              <li>
                All your personal data associated with the account will be
                permanently deleted.
              </li>
              <li>
                This includes profile information, activity history, uploaded
                content, and settings.
              </li>
              <li>This process is irreversible.</li>
            </ul>
          </section>

          <section style={{ maxWidth: "30rem" }} className="w-100 mx-auto my-5">
            <p className="fs_20">Fill the form, we will Reach you</p>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ errors, setFieldValue, values }) => (
                <Form className="">
                  <div className="my-2">
                    <InputField
                      id={"first_name"}
                      label={"Name *"}
                      labelColor={"color_747f9e"}
                      type={"text"}
                      placeholder={"Enter your name"}
                      name={"first_name"}
                      value={values.first_name}
                    />
                  </div>
                  <div className="my-2">
                    <InputField
                      id={"email"}
                      label={"Email Address *"}
                      labelColor={"color_747f9e"}
                      type={"text"}
                      placeholder={"Enter your email address"}
                      name={"email"}
                      value={values.email}
                    />
                  </div>
                  <div className="my-2">
                    <InputField
                      id={"mobile"}
                      label={"Contact Number *"}
                      labelColor={"color_747f9e"}
                      type={"text"}
                      placeholder={"Enter your contact number"}
                      name={"mobile"}
                      value={values.mobile}
                    />
                  </div>
                  <div className="my-2">
                    <label className={`fw_400 fs_14 my-1`}>Description</label>
                    <Field
                      as="textarea"
                      id="description"
                      name="description"
                      rows="4"
                      cols="50"
                      value={values.description}
                      placeholder="Enter your description here"
                      style={{
                        resize: "none",
                        maxWidth: "450px",
                        border: "1px solid #b0b3c7",
                        borderRadius: "7px",
                      }}
                      className="w-100 p-2"
                    />
                    <ErrorMsg name={"description"} />
                  </div>
                  <div
                    className="my-4 text-end"
                    style={{
                      maxWidth: "450px",
                    }}
                  >
                    <button
                      style={{ background: "#7065e4", borderRadius: "7px" }}
                      className="text-white border-0 px-4 py-2 fw_700"
                    >
                      {loading ? <Spinner size="sm" /> : "SUBMIT"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </section>
        </section>
      </section>
      <Footer />
    </main>
  );
};

export default DeletionRequest;
